import type { NDateLocale } from './enUS'
import { nn } from 'date-fns/locale'

const dateNnNO: NDateLocale = {
  name: 'nn-NO',
  locale: nn
}

export default dateNnNO
